import CityPageTemplate from "../city-template/CityPageTemplate";
import { sterlingHeightsConfig } from "./data";

export default function SterlingHeightsPage() {
  return <CityPageTemplate config={sterlingHeightsConfig} />;
}